/* The design they made, big enough to check, from the cart.
 *
 * The cart thumbnail is about 100px wide on a phone, and a customer told us
 * they could not see what they had made (2026-09-16). Tapping it now opens the
 * same preview full screen.
 *
 * The click is delegated from the document on purpose: Dawn re-renders the cart
 * sections on every quantity change, so a listener bound to today's thumbnail
 * would be thrown away with it.
 */
(function () {
  var overlay = null;
  var img = null;
  var opener = null;

  function build() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'mug-zoom__box';
    overlay.hidden = true;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Your design');
    overlay.innerHTML =
      '<button type="button" class="mug-zoom__close" aria-label="Close">×</button>' +
      '<img alt="Your custom design">';
    img = overlay.querySelector('img');
    overlay.addEventListener('click', function (e) {
      // the picture itself is not a target: tapping beside it, or the X, closes
      if (e.target === overlay || (e.target.closest && e.target.closest('.mug-zoom__close'))) close();
    });
    document.body.appendChild(overlay);
  }

  function open(src, from) {
    if (!src) return;
    build();
    img.setAttribute('src', src);
    overlay.hidden = false;
    document.documentElement.classList.add('mug-zoom--on');
    opener = from || null;
    overlay.querySelector('.mug-zoom__close').focus();
  }

  function close() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    document.documentElement.classList.remove('mug-zoom--on');
    img.removeAttribute('src');
    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-mug-zoom]');
    if (!btn) return;
    e.preventDefault();
    open(btn.getAttribute('data-mug-zoom'), btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') close();
  });
})();
